import { singleton } from 'tsyringe';

// -----------------------------------------------------------------------------
@singleton()
export class UtilsService {
  // ---------------------------------------------------------------------------
  public getUrlParam(paramName: string): string {
    paramName = paramName.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${paramName}=([^&#]*)`);
    const results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // ---------------------------------------------------------------------------
  public areObjectsEqual(first: any, second: any): boolean {
    if (first === second) {
      return true;
    }

    if (!first || !second) {
      return false;
    }

    // Create arrays of property names
    const aProps = Object.getOwnPropertyNames(first);
    const bProps = Object.getOwnPropertyNames(second);

    if (aProps.length !== bProps.length) {
      return false;
    }

    for (let i = 0; i < aProps.length; i++) {
      const propName = aProps[i];

      if (first[propName] !== second[propName]) {
        return false;
      }
    }

    return true;
  }
}
